"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getUrlParams = function getUrlParams(input) {
  var params = {};
  var source = window.location.search.slice(1);
  source.split('&').forEach(function (current) {
    var param = current.split('=');
    var _ref = [param[0].toLowerCase(), param[1]],
        key = _ref[0],
        value = _ref[1];
    params[key] = value;
  });
  if (typeof input === 'string') return params[input];

  if (Array.isArray(input)) {
    var requestedParams = {};
    input.forEach(function (key) {
      requestedParams[key] = params[key];
    });
    return requestedParams;
  }

  return params;
};

var _default = getUrlParams;
exports["default"] = _default;